import React, { Component } from 'react'
import moment from 'moment'
import { BaseRequest, MetricsRequest } from 'models/request/Index'
import { getMetrics } from 'services/CeberusApiService'
import { GridView } from 'models/GridView'
import { Card, DatePicker } from 'antd'
import { Tenant } from 'models/Blip/Index'
import { TenantService } from 'connection/TenantService'
import { PushNotification } from 'utils/PushNotification'

const DAYS = 'days';
const MONTH = 'month';
const NO_DATA = 'no data';
const LITERAL_NUMBER_ZERO = 0;
const LITERAL_NUMBER_ONE = 1;
const LITERAL_NUMBER_THIRTY = 30;

const RangePicker = DatePicker.RangePicker;

export class Analytics extends Component<BaseRequest> {

  tenantSelected: Tenant;

  state = {
    ActiveUsersCount: undefined,
    EngagedUsersCount: undefined,
    ActiveMessageCount: undefined,
    isLoading: true
  }

  componentDidMount() {
    this.tenantSelected = TenantService.getSelectedTenant();
    this.getAnalysisInfo(undefined);
  }

  getAnalysisInfo = async (dateRanger: any) : Promise<void> => {
    if (this.props.BotIdentifier) {
      try {
        this.setState({ isLoading: true });
        const updatedDateRanger = this.getFilter(dateRanger);
        const response = await getMetrics(new MetricsRequest(updatedDateRanger, this.tenantSelected.name, this.props.BotIdentifier));
        this.setState({ ...response, dateRangerLocal: updatedDateRanger })
      } catch(error){
        PushNotification.httpError(error);
      }
      finally {
        this.setState({ isLoading: false })
      }
    }
  }

  formatDate(date: any) : string {
    return encodeURIComponent(date.set({
      hour:LITERAL_NUMBER_ZERO,
      minute:LITERAL_NUMBER_ZERO,
      second:LITERAL_NUMBER_ZERO,
      millisecond:LITERAL_NUMBER_ZERO
    }).toISOString())
  }

  getFilter = (dateRanger: any) : string => {
    if(dateRanger == undefined){
      return `startDate=${this.formatDate(moment().subtract(LITERAL_NUMBER_THIRTY, DAYS))}&endDate=${this.formatDate(moment())}`;
    }
    return dateRanger;
  }

  getActiveMessageCount = () : string => {
    if(this.state.ActiveMessageCount != undefined){
      return this.state.ActiveMessageCount;
    }
    return NO_DATA;
  }

  getActiveUsersCount = () : string => {
    if(this.state.ActiveUsersCount != undefined){
      return this.state.ActiveUsersCount;
    }
    return NO_DATA;
  }

  getEngagedUsersCount = () : string => {
    if(this.state.EngagedUsersCount != undefined){
      return this.state.EngagedUsersCount;
    }
    return NO_DATA;
  }

  getAnalysisItems = () : Array<GridView> => {
    return [
      {
        title: 'Active Message:',
        description: this.getActiveMessageCount(),
        key: 'activeMessage',
      },
      {
        title: 'MAU:',
        description: this.getActiveUsersCount(),
        key: 'mau',
      },
      {
        title: 'MEU:',
        description: this.getEngagedUsersCount(),
        key: 'meu',
      },
    ]
  }

  onDateRangeChange = async (dates: any) => {
    if (dates.length > LITERAL_NUMBER_ZERO) {
      const startDate = this.formatDate(dates[LITERAL_NUMBER_ZERO])
      const endDate = this.formatDate(dates[LITERAL_NUMBER_ONE])
      const dateRanger = `startDate=${startDate}&endDate=${endDate}`
      await this.getAnalysisInfo(dateRanger)
    }
  }

  render() {
    const analysisItems = this.getAnalysisItems()

    return (
      <div>
        <Card title="Analytics Information">
          <h4>
            Select a range:
            <RangePicker
              className="ml3"
              defaultValue={[moment().subtract(LITERAL_NUMBER_THIRTY, DAYS), moment()]}
              defaultPickerValue={[moment().subtract(LITERAL_NUMBER_THIRTY, DAYS), moment()]}
              ranges={{
                Today: [moment(), moment()],
                'This Month': [moment().startOf(MONTH), moment().endOf(MONTH)],
                'Last 30 Days': [moment().subtract(LITERAL_NUMBER_THIRTY, DAYS), moment()]
              }}
              format="DD/MM/YYYY"
              onChange={this.onDateRangeChange}
              allowClear={false}
            />
          </h4>
          <div className="flex justify-between mt4">
            {analysisItems.map((item) =>
              <Card key={item.key} title={item.title} className="w-30" loading={this.state.isLoading}>
                {item.description}
              </Card>
            )}
          </div>
        </Card>
      </div>
    )
  }
}